import { render, staticRenderFns } from "./FirstNationGrid.vue?vue&type=template&id=57316e21"
import script from "./FirstNationGrid.vue?vue&type=script&lang=js"
export * from "./FirstNationGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports